import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeGoogleCalendarCreate,
  detail: routeGoogleCalendarDetail,
  home: routeGoogleCalendarHome,
  root: routeGoogleCalendarRoot,
} = createDoctypeRoutes({
  createName: 'new-google-calendar',
  createPath: 'new-google-calendar',
  detailName: 'google-calendar-detail',
  doctype: DOCTYPES.GOOGLE_CALENDAR,
  homeName: 'google-calendar',
  path: 'google-calendar',
  views: {
    create: async () =>
      await import(
        '@/components/viewsExternal/settings/google/googleCalendar/AddGoogleCalendar.vue'
      ),
    detail: async () =>
      await import(
        '@/components/viewsExternal/settings/google/googleCalendar/ViewGoogleCalendar.vue'
      ),
    list: async () =>
      await import('@/components/viewsExternal/settings/interfaces/ViewInterfaces.vue'),
  },
})

export {
  routeGoogleCalendarCreate,
  routeGoogleCalendarDetail,
  routeGoogleCalendarHome,
  routeGoogleCalendarRoot,
}
